<template>
  <ContentInfoLinks :links="links" />
</template>

<script>
import ContentInfoLinks from 'chimera/all/themes/blueflow/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      links: [
        {
          title: 'Algemeen',
          to: '/informatie-over-kozijnen/',
        },
        {
          title: 'Aluminium kozijnen',
          to: '/informatie-over-kozijnen/aluminium',
        },
        {
          title: 'Kunststof kozijnen',
          to: '/informatie-over-kozijnen/kunststof',
        },
        {
          title: 'Houten kozijnen',
          to: '/informatie-over-kozijnen/hout',
        },
        {
          title: 'Hardhouten kozijnen',
          to: '/informatie-over-kozijnen/hardhout',
        },
        {
          title: 'Op maat laten maken',
          to: '/informatie-over-kozijnen/op-maat',
        },
        {
          title: 'Prijzen',
          to: '/informatie-over-kozijnen/prijzen',
        },
        {
          title: 'Kozijnen vervangen',
          to: '/informatie-over-kozijnen/vervangen',
        },
        {
          title: 'Veelgestelde vragen',
          to: '/informatie-over-kozijnen/veelgestelde-vragen',
        },
      ],
    }
  },
}
</script>
